import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { API_URLS } from '../../models/contant';
import { Constants } from '../../models/contant';
@Injectable({
  providedIn: 'root',
})
export class CaptchaService {
  constructor(private httpClient: HttpClient) { }

  loadCaptcha(): Observable<any> {
    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.CAPTCHA.GENERATE}`;
    return this.httpClient.post(url, {});
  }
  validateCaptcha(captchaValue: any, captchaId: any): Observable<any> {
    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.CAPTCHA.VALIDATE}`;
    let params = new HttpParams();
    params = params.append('captchaId', captchaId);
    params = params.append('userInput', captchaValue);

    console.log('Params: ', params);
    return this.httpClient.post(url, params);
  }

  refreshCaptcha(captchaId: any): Observable<any> {
    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.CAPTCHA.REFRESH}`;
    let params = new HttpParams()
    params = params.append('captchaId', captchaId);
    return this.httpClient.post(url, params);
  }

  receiptLookup(sellerBrn: string, receiptType: string, receiptNo: string, receiptDate: string, recTotalPayAmount: string): Observable<any> {
    //receiptLookup(reqData : any): Observable<any> {
    console.log("receiptLookupEntered");
    console.log("sellerBrn", sellerBrn);
    console.log("receiptType", receiptType);
    console.log("receiptNo", receiptNo);
    console.log("receiptDate", receiptDate);
    console.log("recTotalPayAmount", recTotalPayAmount);

    //const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const url = `${Constants.CONSUMER_BASE_API_URL}${API_URLS.RECEIPT.LOOKUP}`;

    let reqs = new HttpParams();
    reqs = reqs.append('sellerBrn', sellerBrn)
    reqs = reqs.append('receiptType', receiptType)
    reqs = reqs.append('receiptNo', receiptNo);
    reqs = reqs.append('receiptDate', receiptDate);
    reqs = reqs.append('recTotalPayAmount', recTotalPayAmount);
    return this.httpClient.post<any>(url, reqs);
    //return this.httpClient.post<any>(url, reqs,{});

    //  return this.httpClient.post<any>(url,
    //    {'sellerBrn': sellerBrn
    //     ,'receiptType': receiptType
    //     ,'receiptNo': receiptNo
    //     ,'receiptDate': receiptDate
    //     ,'recTotalPayAmount': recTotalPayAmount
    //    }
    //   ,{responseType: 'json'
    //     ,observe: 'response'
    //   });

    // return this.httpClient.post<any>(url,
    //   {reqData}
    //  ,{headers: headers,
    //   responseType: 'json',
    //   withCredentials: true,
    //   observe: 'response'
    //  });
  }
}
